import React from 'react'

import { connect } from 'react-redux'
import { Item, Box } from 'react-html-email';

import Row from "./row"

class Footer extends React.Component {

  render() {
    const footerContent = this.props.footer.map((content, index) => (
      <Item key={index} align={content.align}>
        <Row content={content} html={this.props.html} section="footer" index={index}/>
      </Item>
    ));

    return (
      <Box width="100%" >
        {footerContent}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return { 
    footer: state.design.footer,
    folder: state.design.folder
  }
}

export default connect(
  mapStateToProps
)(Footer)